var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-page",attrs:{"id":_vm.id}},[_c('InternalMenu',{attrs:{"links":_vm.post.children}}),_c('h1',[_vm._v(_vm._s(_vm.post.title.rendered))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }